import "./Splash.scss"

import React, { FunctionComponent } from "react"

import Spinner from "components/Spinner/Spinner"

const Splash: FunctionComponent<React.PropsWithChildren<unknown>> = () => {
    return (
        <div className="splash">
            <Spinner />
        </div>
    )
}

export default Splash
